var map = {
	"./audio-placeholder": 700,
	"./audio-placeholder.png": 700,
	"./avatar-missing": 640,
	"./avatar-missing.png": 640,
	"./avatar-missing.svg": 780,
	"./halloween/clouds": 701,
	"./halloween/clouds.png": 701,
	"./halloween/halloween-emblem": 708,
	"./halloween/halloween-emblem.svg": 708,
	"./halloween/spider": 709,
	"./halloween/spider.svg": 709,
	"./halloween/spiderweb": 710,
	"./halloween/spiderweb.svg": 710,
	"./halloween/starfield": 711,
	"./halloween/starfield.png": 711,
	"./halloween/twinkle": 712,
	"./halloween/twinkle.svg": 712,
	"./header-missing": 665,
	"./header-missing.png": 665,
	"./reticle": 713,
	"./reticle.png": 713,
	"./soapbox-logo": 666,
	"./soapbox-logo-white": 667,
	"./soapbox-logo-white.svg": 667,
	"./soapbox-logo.svg": 666,
	"./sprite-post-functions": 714,
	"./sprite-post-functions.png": 714,
	"./video-placeholder": 715,
	"./video-placeholder.png": 715,
	"./void": 716,
	"./void.png": 716,
	"./web-push/web-push-icon_expand": 741,
	"./web-push/web-push-icon_expand.png": 741,
	"./web-push/web-push-icon_favourite": 742,
	"./web-push/web-push-icon_favourite.png": 742,
	"./web-push/web-push-icon_reblog": 743,
	"./web-push/web-push-icon_reblog.png": 743
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 779;